(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.competitors', [
    'clientDashboardApp.admin.competitors.competitorsManagerService'
  ]).controller("CompetitorsManagerCtrl", CompetitorsManagerCtrl);

  CompetitorsManagerCtrl.$inject = ['competitorsManagerService', '$state', '$location', 'updateService', 'stringService', '$sce', 'confirmService'];
  function CompetitorsManagerCtrl(competitorsManagerService, $state, $location, updateService, stringService, $sce, confirmService) {
    var vm = this;

    vm.locationId = $state.params.locationId;

    var states = {
      LoadingData: 'LoadingData',
      UserEditing: 'UserEditing'
    };

    vm.state = {
      editor: states.LoadingData,
      updating: false
    }

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    }

    vm.pageStrings = stringService.adminStrings();

    var resetPage = function () {
      vm.submitted = false;
      delete vm.customerLocation;
      delete vm.competitorLocations;
    };

    vm.formatAddress = function (locDetails) {
      var addressStr = [];
      if (locDetails.street)
        addressStr.push(locDetails.street);

      if (locDetails.city)
        addressStr.push(locDetails.city);

      if (locDetails.state && locDetails.postalCode) {
        addressStr.push(locDetails.state + ' ' + locDetails.postalCode);
      } else if (locDetails.state) {
        addressStr.push(locDetails.state);
      } else if (locDetails.postalCode) {
        addressStr.push(locDetails.postalCode);
      }

      if (locDetails.country)
        addressStr.push(locDetails.country);

      return addressStr.join(', ')
    };

    vm.canAddCompetitor = function () {
      return vm.state.editor==states.UserEditing ? vm.competitorLocations.length < 5 : false;
    };

    vm.openCreateCompetitor = function (locationId) {
      if(vm.canAddCompetitor()){
        $location.path("/admin/v2/locations/"+locationId+"/competitors/create");
      }
    }

    vm.cleanUrl = function (url) {
      if (url && !url.startsWith('http')) {
        return 'http://' + url;
      }
      return url;
    };

    vm.removeCompetitor = function (competitorDetails) {
      confirmService.confirm('Confirm Remove Competitor', 'Are you sure you want to remove this competitor?', confirmService.DELETE)
        .then(confirmed => {
          if (!confirmed) {
            return;
          }
          vm.state.updating = true;
          competitorDetails.status = 'Deleting';
          //Remove and update backend
          competitorsManagerService.deleteCompetitor(vm.locationId, competitorDetails.locationId).success(function () {
            competitorDetails.status = 'Deleted';
            var updateInfo = {
              status: "Active",
              type: "competitor",
              title: "Competitor",
              destinationRole: "manage",
              notificationType: "detail",
              actions: [{action:"delete"}],
              entity: competitorDetails,
              id: competitorDetails.locationId,
              name: competitorDetails.busName,
              searchParam: ""
            }
            updateService.registerSuccessfulUpdate(updateInfo);
            $state.reload();
          }).error(function () {
            competitorDetails.status = 'An error occurred when deleting competitor';
          });
        })
    };

    vm.submitChanges = function () {
      vm.submitted = true;
    };

    var handleCompetitorViewData = function (resp) {
      var competitorData = resp.data;
      vm.customerLocation = competitorData.locationDetails;
      vm.competitorLocations = competitorData.competitorsDetails;
      vm.state.editor = states.UserEditing;
    };

    reload();

    function reload() {
      vm.state.editor = states.LoadingData;
      resetPage();
      competitorsManagerService.listCompetitors(vm.locationId).then(handleCompetitorViewData);
    }
  }
})();
